import { googleConfig } from "./config";

type TokenResponse = { access_token?: string; error?: string; error_description?: string };
type TokenClient = { requestAccessToken: (options?: { prompt?: string }) => void };

declare global {
  interface Window {
    google?: { accounts?: { oauth2?: { initTokenClient: (options: { client_id: string; scope: string; callback: (response: TokenResponse) => void }) => TokenClient } } };
  }
}

async function waitForGoogleIdentity() {
  for (let attempt = 0; attempt < 40; attempt += 1) {
    if (window.google?.accounts?.oauth2) return;
    await new Promise(resolve => window.setTimeout(resolve, 150));
  }
  throw new Error("Google 로그인 도구를 불러오지 못했습니다. 네트워크를 확인한 뒤 다시 시도해 주세요.");
}

export async function requestGoogleSheetsToken() {
  await waitForGoogleIdentity();
  return new Promise<string>((resolve, reject) => {
    const client = window.google?.accounts?.oauth2?.initTokenClient({
      client_id: googleConfig.clientId,
      scope: googleConfig.scope,
      callback: response => response.access_token ? resolve(response.access_token) : reject(new Error(response.error_description || response.error || "Google 로그인 권한을 받지 못했습니다.")),
    });
    if (!client) return reject(new Error("Google 로그인 설정을 초기화하지 못했습니다."));
    client.requestAccessToken({ prompt: "select_account" });
  });
}
